/**
 * Formats seconds into MM:SS format
 * @param seconds - Total seconds
 * @returns Formatted time string (e.g., "25:00", "04:32")
 */
export function formatTime(seconds: number): string {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  
  return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
}

/**
 * Converts minutes to seconds
 * @param minutes - Duration in minutes
 * @returns Duration in seconds
 */
export function minutesToSeconds(minutes: number): number {
  return minutes * 60;
}

/**
 * Converts seconds to minutes (rounded)
 * @param seconds - Duration in seconds
 * @returns Duration in minutes
 */
export function secondsToMinutes(seconds: number): number {
  return Math.round(seconds / 60);
}

/**
 * Gets display text for remaining time
 * @param seconds - Remaining seconds
 * @returns Descriptive text (e.g., "25 minutes left", "30 seconds left")
 */
export function getTimeLeftText(seconds: number): string {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  
  if (minutes > 0) {
    return `${minutes} minute${minutes === 1 ? '' : 's'} left`;
  } else {
    return `${remainingSeconds} second${remainingSeconds === 1 ? '' : 's'} left`;
  }
} 